var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250.894,
    height: 207.288,
    viewBox: "0 0 250.894 207.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(-356.3 -28.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(356.3 158.514)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M378.809,673.545a10.064,10.064,0,0,0-.675-2.19,1.235,1.235,0,0,1,.184-1.289l1.248-1.535-1.883-2.292-1.739.921a1.26,1.26,0,0,1-1.31-.082,10.7,10.7,0,0,0-2.026-1.084,1.233,1.233,0,0,1-.778-1.044l-.184-1.964L368.7,662.7l-.573,1.9a1.245,1.245,0,0,1-.982.859,10.057,10.057,0,0,0-2.189.675,1.235,1.235,0,0,1-1.289-.184l-1.535-1.248-2.292,1.883.921,1.739a1.26,1.26,0,0,1-.082,1.31,10.706,10.706,0,0,0-1.085,2.026,1.233,1.233,0,0,1-1.044.778l-1.964.184-.286,2.947,1.9.573a1.245,1.245,0,0,1,.859.982,10.058,10.058,0,0,0,.675,2.19,1.229,1.229,0,0,1-.184,1.289l-1.248,1.535,1.883,2.292,1.739-.921a1.26,1.26,0,0,1,1.31.082,10.706,10.706,0,0,0,2.026,1.085,1.233,1.233,0,0,1,.778,1.044l.184,1.964,2.947.286.573-1.9a1.245,1.245,0,0,1,.982-.859,10.06,10.06,0,0,0,2.189-.675,1.235,1.235,0,0,1,1.289.184l1.535,1.248,2.292-1.883-.921-1.739a1.26,1.26,0,0,1,.082-1.31,10.7,10.7,0,0,0,1.085-2.026,1.233,1.233,0,0,1,1.044-.778l1.964-.184.286-2.947-1.9-.573A1.311,1.311,0,0,1,378.809,673.545Zm-10.6,9.29a7.526,7.526,0,1,1,8.226-6.753A7.529,7.529,0,0,1,368.209,682.835Z",
    transform: "translate(-356.3 -662.7)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M393.608,704.41a5.017,5.017,0,1,1,4.5,5.484A5.011,5.011,0,0,1,393.608,704.41Z",
    transform: "translate(-385.955 -692.275)",
    fill: "#2a94f4"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 92.594,
    cy: 7.489,
    rx: 92.594,
    ry: 7.489,
    transform: "translate(377.827 221.109)",
    fill: "#2a94f4",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(385.726 31.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M776.8,509.585a3.153,3.153,0,0,0,3.151,3.151H893.172a3.153,3.153,0,0,0,3.151-3.151V412.1H776.82v97.485Z",
    transform: "translate(-720.18 -336.613)",
    fill: "#5ebbfe",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M922.285,542.429a25.641,25.641,0,0,0,2.21,5.32,3.143,3.143,0,0,1-.123,3.274l-2.742,4.113,5.259,5.259L931,557.653a3.143,3.143,0,0,1,3.274-.123,24.744,24.744,0,0,0,5.32,2.21,3.191,3.191,0,0,1,2.23,2.415l.962,4.85h7.428l.982-4.87a3.155,3.155,0,0,1,2.23-2.415,25.639,25.639,0,0,0,5.32-2.21,3.143,3.143,0,0,1,3.274.123l4.113,2.742,5.259-5.259L968.653,551a3.143,3.143,0,0,1-.123-3.274,24.748,24.748,0,0,0,2.21-5.32,3.191,3.191,0,0,1,2.415-2.23l4.85-.962v-7.428l-4.87-.982a3.155,3.155,0,0,1-2.415-2.231,25.639,25.639,0,0,0-2.21-5.32,3.143,3.143,0,0,1,.123-3.274l2.742-4.113-5.259-5.259L962,513.352a3.143,3.143,0,0,1-3.274.123,24.751,24.751,0,0,0-5.32-2.21,3.191,3.191,0,0,1-2.23-2.415l-.962-4.85h-7.428l-.982,4.87a3.155,3.155,0,0,1-2.23,2.415,25.636,25.636,0,0,0-5.32,2.21,3.143,3.143,0,0,1-3.274-.123l-4.113-2.742-5.259,5.259L924.351,520a3.143,3.143,0,0,1,.123,3.274,24.748,24.748,0,0,0-2.21,5.32,3.191,3.191,0,0,1-2.415,2.23l-4.85.962v7.428l4.87.982A3.1,3.1,0,0,1,922.285,542.429Zm24.187-25.8A18.867,18.867,0,1,1,927.6,535.492,18.872,18.872,0,0,1,946.472,516.626Z",
    transform: "translate(-830.1 -409.707)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M776.8,322.951v9.433H896.3v-9.433a3.153,3.153,0,0,0-3.151-3.151H779.931A3.135,3.135,0,0,0,776.8,322.951Zm31.451,0h6.282v6.3h-6.282Zm-12.585,0h6.282v6.3h-6.282Zm-12.585,0h6.282v6.3h-6.282Z",
    transform: "translate(-720.18 -263.2)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M1032.469,609.085a12.585,12.585,0,1,1-12.585-12.585A12.589,12.589,0,0,1,1032.469,609.085Z",
    transform: "translate(-903.513 -483.279)",
    fill: "#bfe4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M619.623,46.351a3.153,3.153,0,0,0-3.151-3.151H503.251a3.153,3.153,0,0,0-3.151,3.151v9.433H619.6V46.351ZM512.685,52.633H506.4V46.351h6.282Zm12.585,0h-6.282V46.351h6.282Zm12.585,0h-6.282V46.351h6.282Z",
    transform: "translate(-500.1 -43.2)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M550.418,176.285a9.423,9.423,0,0,1,9.433-9.433H619.6V135.4H500.1v97.485a3.153,3.153,0,0,0,3.151,3.151h47.167Zm25.169-25.149h6.282v6.282h-6.282Zm-12.585,0h6.282v6.282H563Zm-12.585,0H556.7v6.282h-6.282ZM537.854,226.6H512.685v-6.282h25.169Zm0-12.585H512.685v-6.282h25.169Zm0-12.564H512.685v-6.282h25.169Zm0-12.585H512.685v-6.282h25.169Zm0-12.585H512.685V170h25.169Zm0-18.867v-6.282h6.282v6.282Z",
    transform: "translate(-500.1 -116.533)",
    fill: "#5ebbfe",
    opacity: 0.59
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M866.3,754.215l.123-3.315,2.353.716.45,4.134S866.975,755.893,866.3,754.215Z",
    transform: "translate(-791.365 -606.085)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M857.707,764.178a4.347,4.347,0,0,0,2.619.164l-.143-.941a1.941,1.941,0,0,1,.818,1.248c.164.839.2.614,1.269,1.269a2.494,2.494,0,0,1,1,2.128l-8.021-.2a4.6,4.6,0,0,1,1.228-3.335A1.05,1.05,0,0,1,857.707,764.178Z",
    transform: "translate(-782.567 -616.027)",
    fill: "#0e538c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M802.606,527.4s-1.044,4.072.43,6.63,4.133-3.11,4.133-3.11S806.7,525.477,802.606,527.4Z",
    transform: "translate(-740.42 -427.992)",
    fill: "#ffbe55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M774.372,434.6s-5.4,7.346-6.3,11.787c-.921,4.44.061,14.14.061,14.14h2.21s1.166-12.38,1.9-14.14c.737-1.8,5.525-10.109,5.525-10.109Z",
    transform: "translate(-712.922 -354.509)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(46.676 111.768)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 20.504,
    height: 2.353,
    transform: "translate(13.853 39.882)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 22.038,
    height: 2.353,
    transform: "translate(9.474 56.129)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 22.038,
    height: 2.353,
    transform: "translate(7.489 71.845)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M744.456,686.184H742L760.089,601.1h1.371Z",
    transform: "translate(-739.176 -598.706)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M869.755,676.878H867.3L881.644,589.4l1.207.573Z",
    transform: "translate(-838.836 -589.4)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M754.147,676.878l13.2-84.941-18.232-.143-18.089,85.084H728.2L746.576,589.4h24.433l-13.567,87.478h-3.7",
    transform: "translate(-728.2 -589.4)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M814.5,754.215l.123-3.315,2.353.716.45,4.134C817.406,755.75,815.175,755.893,814.5,754.215Z",
    transform: "translate(-750.165 -606.085)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M916.9,350.617s5.832-.43,6.528-3.131S924,337.5,924,337.5h2.026s1.391,6.773,1.31,9.986-3.99,8.7-10.436,8.349C910.475,355.487,916.9,350.617,916.9,350.617Z",
    transform: "translate(-829.34 -277.278)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M798.856,399.9s-3.376.348-4.768,1.821c-.675.716-4.87,5.914-4.706,7.039l4.932,3.069,4.031-5.586Z",
    transform: "translate(-730.183 -326.909)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M807.293,511.987a16.553,16.553,0,0,0-.082,9c1.371,4.706,1.371,14.2,1.248,16.677s-2.435,9.638-.471,22.284h3.029s1.842-13.26,2.906-18.908c1-5.3,2.271-18.519,2.271-18.519S820,535.069,819.366,538.3c-.7,3.561-.778,21.629-.778,21.629h3.049s3.417-15.552,3.622-19.726c.225-4.174-.246-27.584-.246-27.584S814.864,505.725,807.293,511.987Z",
    transform: "translate(-743.9 -413.97)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M848.69,360l-3.09,9.454,5.586,1.1,1.228-9.8Z",
    transform: "translate(-774.901 -295.174)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M820.5,395.491s3.786.778,4.174,5.73.921,26.07.921,27.891c-.123.839-14.836,3.642-19.215-.614-1.1-1.085,2.517-19.46,2.005-24.289C807.854,399.4,810.718,393.281,820.5,395.491Z",
    transform: "translate(-743.539 -323.032)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M873.44,405.836a7.245,7.245,0,0,1,6.2-3.806s1.125-3.213,0-5.218c0,0-8.492-1.739-11.725-1.085S873.44,405.836,873.44,405.836Z",
    transform: "translate(-792.08 -323.473)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M957.2,319.827s.634-3.4-.491-5.32c-.675-1.146-1.412-1.678-2.149-1.473-.491.143-.7,1-.573,1.494a18.827,18.827,0,0,0,.982,2.865s-.512,0-1.044-1.146c-.512-1.125-.9.532-.491,1.31C954.049,318.681,956.074,321.771,957.2,319.827Z",
    transform: "translate(-860.534 -257.783)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M805.807,764.178a4.347,4.347,0,0,0,2.619.164l-.143-.941a1.941,1.941,0,0,1,.819,1.248c.164.839.2.614,1.269,1.269a2.494,2.494,0,0,1,1,2.128l-8.021-.2a4.6,4.6,0,0,1,1.228-3.335A1.058,1.058,0,0,1,805.807,764.178Z",
    transform: "translate(-741.288 -616.027)",
    fill: "#0e538c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M849.78,328.192c-.143-1.187,2.435-1.985-2.5-5.464-2.517-1.76-6.9-.982-8.247,1.678s-.634,2.926-1.678,3.11c-1.044.2.061,8.431,6.364,8.328C850.046,335.742,849.78,328.192,849.78,328.192Z",
    transform: "translate(-768.072 -264.777)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M813.6,406.6",
    transform: "translate(-749.449 -332.238)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M803.888,515h19.194a1.49,1.49,0,0,1,1.494,1.33c.327,2.885.675,9.433-2.7,9.9-4.338.614-5.73-4.072-5.73-8.431l-12.605.061S803.11,515.778,803.888,515Z",
    transform: "translate(-741.353 -418.457)",
    fill: "#ffbe55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M769.9,561.3",
    transform: "translate(-714.691 -455.282)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M769.243,555.7s-.368,4.359,1.044,5.545c1.412,1.207-2.5,1.739-3.458-.471s.348-5.075.348-5.075Z",
    transform: "translate(-711.968 -450.828)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M775.822,558.5a2.494,2.494,0,0,1,1.8,1.637,11.675,11.675,0,0,1,.532,2.251.444.444,0,0,1-.716.409,1.356,1.356,0,0,1-.594-1.248c.1-1.33-1.494-.941-1.494-.941S774.82,559.032,775.822,558.5Z",
    transform: "translate(-718.915 -453.055)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M879,516.974h-1v-2.967a.315.315,0,0,1,.307-.307h.409a.315.315,0,0,1,.307.307v2.967Z",
    transform: "translate(-800.671 -417.423)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M886.3,520.871h-1v-1.964a.315.315,0,0,1,.307-.307h.409a.315.315,0,0,1,.307.307v1.964Z",
    transform: "translate(-806.477 -421.32)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M894.091,511.486H892.7v-4.277a.41.41,0,0,1,.409-.409h.573a.41.41,0,0,1,.409.409Z",
    transform: "translate(-812.363 -411.935)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 7.735,
    height: 0.655,
    transform: "translate(75.119 99.551)",
    fill: "#161616",
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(368.332 178.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M444.219,772.891a13.492,13.492,0,0,0-1.391-2.7,1.675,1.675,0,0,1-.082-1.719l1.269-2.292-2.988-2.537-2.046,1.637a1.637,1.637,0,0,1-1.719.2,13.16,13.16,0,0,0-2.885-.921,1.643,1.643,0,0,1-1.269-1.166l-.716-2.5-3.908.327-.307,2.6a1.683,1.683,0,0,1-1.064,1.371,13.494,13.494,0,0,0-2.7,1.391,1.674,1.674,0,0,1-1.719.082L420.4,765.4l-2.537,2.988,1.637,2.046a1.637,1.637,0,0,1,.2,1.719,13.159,13.159,0,0,0-.921,2.885,1.642,1.642,0,0,1-1.166,1.269l-2.517.716.327,3.908,2.6.307A1.683,1.683,0,0,1,419.4,782.3a13.5,13.5,0,0,0,1.391,2.7,1.674,1.674,0,0,1,.082,1.719l-1.269,2.292,2.988,2.537,2.046-1.637a1.637,1.637,0,0,1,1.719-.2,13.166,13.166,0,0,0,2.885.921,1.642,1.642,0,0,1,1.269,1.166l.716,2.517,3.908-.327.307-2.6a1.683,1.683,0,0,1,1.064-1.371,13.5,13.5,0,0,0,2.7-1.391,1.675,1.675,0,0,1,1.719-.082l2.292,1.269,2.537-2.987-1.637-2.046a1.637,1.637,0,0,1-.2-1.719,13.157,13.157,0,0,0,.921-2.885A1.642,1.642,0,0,1,446,778.907l2.517-.716-.327-3.908-2.6-.307A1.743,1.743,0,0,1,444.219,772.891Zm-11.582,14.631a9.969,9.969,0,1,1,9.106-10.763A9.985,9.985,0,0,1,432.637,787.522Z",
    transform: "translate(-415.1 -760.9)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M464.308,817.191a6.644,6.644,0,1,1,7.182,6.057A6.649,6.649,0,0,1,464.308,817.191Z",
    transform: "translate(-454.22 -799.94)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(396.182 154.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M584.329,653.779a16.977,16.977,0,0,0-3.213-2.292,2.136,2.136,0,0,1-1.105-1.944l.1-3.4L575.162,645l-1.391,3.09a2.147,2.147,0,0,1-1.862,1.269,16.794,16.794,0,0,0-3.888.655,2.145,2.145,0,0,1-2.169-.594l-2.312-2.476-4.318,2.681,1.187,3.192a2.137,2.137,0,0,1-.43,2.21,16.978,16.978,0,0,0-2.292,3.213,2.136,2.136,0,0,1-1.944,1.105l-3.4-.1-1.146,4.952,3.09,1.391a2.147,2.147,0,0,1,1.269,1.862,17.928,17.928,0,0,0,.634,3.888,2.145,2.145,0,0,1-.593,2.169l-2.476,2.312,2.681,4.318L559,678.927a2.145,2.145,0,0,1,2.21.43,16.969,16.969,0,0,0,3.213,2.292,2.1,2.1,0,0,1,1.105,1.944l-.1,3.4,4.952,1.146,1.391-3.09a2.147,2.147,0,0,1,1.862-1.269,17.934,17.934,0,0,0,3.888-.634,2.145,2.145,0,0,1,2.169.593L582,686.212l4.318-2.681-1.187-3.192a2.137,2.137,0,0,1,.43-2.21,16.979,16.979,0,0,0,2.292-3.213,2.136,2.136,0,0,1,1.944-1.105l3.4.1,1.146-4.952-3.09-1.391a2.147,2.147,0,0,1-1.269-1.862,17.936,17.936,0,0,0-.634-3.888,2.145,2.145,0,0,1,.593-2.169l2.476-2.312-2.681-4.318-3.192,1.187A2.236,2.236,0,0,1,584.329,653.779Zm-4.706,23.757a12.937,12.937,0,1,1,4.134-17.823A12.94,12.94,0,0,1,579.623,677.536Z",
    transform: "translate(-551.2 -645)",
    fill: "#cce9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M615.823,721.392a8.617,8.617,0,1,1,11.868,2.762A8.607,8.607,0,0,1,615.823,721.392Z",
    transform: "translate(-601.561 -695.281)",
    fill: "#cce9ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(564.611 57.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M1382.178,179.768a15.993,15.993,0,0,0-1.985,3.315,2.129,2.129,0,0,1-1.821,1.248l-3.336.164-.737,4.932,3.131,1.125a2.13,2.13,0,0,1,1.371,1.719,15.7,15.7,0,0,0,.941,3.745,2.11,2.11,0,0,1-.409,2.169l-2.23,2.456,2.967,4.011,3.028-1.412a2.121,2.121,0,0,1,2.189.246,16,16,0,0,0,3.315,1.985,2.128,2.128,0,0,1,1.248,1.821l.164,3.335,4.931.737,1.125-3.131a2.13,2.13,0,0,1,1.719-1.371,15.706,15.706,0,0,0,3.745-.941,2.111,2.111,0,0,1,2.169.409l2.455,2.251,4.011-2.967-1.412-3.029a2.122,2.122,0,0,1,.245-2.19,15.992,15.992,0,0,0,1.985-3.315,2.128,2.128,0,0,1,1.821-1.248l3.335-.164.737-4.932-3.131-1.125a2.13,2.13,0,0,1-1.371-1.719,15.707,15.707,0,0,0-.941-3.745,2.11,2.11,0,0,1,.409-2.169l2.251-2.456-2.967-4.011-3.029,1.412a2.121,2.121,0,0,1-2.19-.246,15.988,15.988,0,0,0-3.315-1.985,2.128,2.128,0,0,1-1.248-1.821l-.164-3.335-4.932-.737-1.126,3.131a2.13,2.13,0,0,1-1.719,1.371,15.7,15.7,0,0,0-3.745.941,2.11,2.11,0,0,1-2.169-.409l-2.456-2.251-4.011,2.967,1.412,3.029A2.172,2.172,0,0,1,1382.178,179.768Zm23.594,2.762a12.685,12.685,0,1,1-17.741-2.66A12.7,12.7,0,0,1,1405.772,182.531Z",
    transform: "translate(-1374.3 -168.8)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M1450.375,246.655a8.458,8.458,0,1,1,1.78-11.827A8.443,8.443,0,0,1,1450.375,246.655Z",
    transform: "translate(-1424.081 -218.581)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(516.524 28.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M1144.764,51.882a22.9,22.9,0,0,0-.348,5.013,2.757,2.757,0,0,1-1.371,2.517l-3.745,2.149,2.067,6.139,4.3-.552a2.746,2.746,0,0,1,2.6,1.166,22.439,22.439,0,0,0,3.295,3.786,2.758,2.758,0,0,1,.8,2.742L1151.23,79l5.791,2.885,2.66-3.417a2.735,2.735,0,0,1,2.66-1.023,21.7,21.7,0,0,0,5.013.348,2.757,2.757,0,0,1,2.517,1.371l2.148,3.745,6.139-2.067-.552-4.3a2.746,2.746,0,0,1,1.166-2.6,21.555,21.555,0,0,0,3.786-3.295,2.758,2.758,0,0,1,2.742-.8l4.174,1.125,2.885-5.811-3.438-2.66a2.736,2.736,0,0,1-1.023-2.66,21.685,21.685,0,0,0,.348-5.013,2.8,2.8,0,0,1,1.371-2.517l3.745-2.149-2.067-6.139-4.3.552a2.747,2.747,0,0,1-2.6-1.166,21.562,21.562,0,0,0-3.294-3.786,2.758,2.758,0,0,1-.8-2.742l1.126-4.174-5.771-2.885L1173,33.24a2.735,2.735,0,0,1-2.66,1.023,21.7,21.7,0,0,0-5.013-.348,2.757,2.757,0,0,1-2.517-1.371l-2.149-3.745-6.139,2.067.552,4.3a2.746,2.746,0,0,1-1.166,2.6,21.559,21.559,0,0,0-3.786,3.295,2.758,2.758,0,0,1-2.742.8l-4.174-1.125-2.885,5.811,3.417,2.66A2.673,2.673,0,0,1,1144.764,51.882ZM1173.677,41.1a16.472,16.472,0,1,1-22.079,7.428A16.491,16.491,0,0,1,1173.677,41.1Z",
    transform: "translate(-1139.3 -28.8)",
    fill: "#cce9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M1238.6,123.25a10.977,10.977,0,1,1-4.952-14.713A10.982,10.982,0,0,1,1238.6,123.25Z",
    transform: "translate(-1201.728 -91.307)",
    fill: "#cce9ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateImg);
export default __webpack_public_path__ + "static/media/create-img.ec2a3c5b331c52e478fed28b0e0a453a.svg";
export { ForwardRef as ReactComponent };